export const SHELL_HELP_TEXT = `Here's what Vaiu Shell can do (same capabilities as vaiu.app, via natural language):

💰 **Balances & money**
• "show balances" / "balance USD" / "what's my balance?"
• "topup $100" / "add funds" → opens top-up (or funds via payment UI)
• "transfer out USD" / "withdraw" → off-platform payout flow

🪙 **Tokens & payments**
• "create $50 token" / "make 25 EUR payment"
• "create invoice for $100"
• "create $20 token from my visa card" (auto-fund if needed)
• "redeem ABC123" / "use token XYZ789"
• "token info ABC123"

📜 **History & account**
• "transactions" / "transactions last 7 days"
• "show my profile" / "who am i"
• "payment methods" / "my cards"

👥 **People & merchants**
• "list contacts" / "search contacts john"
• "search merchants coffee"
• "open marketplace" / "go to inbox"

🔗 **Navigation** (opens the same screens as the app menu)
• "go to profile" / "open topup" / "open transfer" / "open memoney"
• "open referral tokens" / "open support" / "merchant tools"

📦 **Batch scripts** — use Script Upload with one command per line (# for comments)

Type naturally — I'll call the same APIs the app UI uses. For flows that need card entry or 3DS, I'll open the right screen for you.`;

export const SHELL_HELP_TEXT_NO_TOKEN_CREATE = `Here's what Vaiu Shell can do in the developer app:

💰 **Balances & money**
• "show balances" / "balance USD" / "what's my balance?"

🪙 **Tokens**
• "redeem ABC123" / "use token XYZ789"
• "token info ABC123"
• Cash and invoice tokens are created on vaiu.app, not here.

📜 **History & account**
• "transactions" / "transactions last 7 days"
• "show my profile" / "who am i"
• "payment methods" / "my cards"

👥 **People & merchants**
• "list contacts" / "search contacts john"
• "search merchants coffee"
• "open marketplace" / "go to inbox"

🔗 **Navigation**
• "go to profile" / "open support"

📦 **Batch scripts** — use Script Upload with one command per line (# for comments)

Token generation is not available in this app.`;
